// components/AppDatePicker.tsx
import { CustomDatePicker } from '@arredo/reactjs-ui';
import dayjs from 'dayjs';

export const WrapperDatePicker = ({ filters: value, handleFilterChange, type = 'startDate', inputProps }) => {
    const getLabel = () => {
        if (!value) return 'dd/mm/aaaa';
        return type === 'startDate' || type === 'from' ? 'Desde' : 'Hasta';
    };

    return (
        <CustomDatePicker
            label={getLabel()}
            value={value ? dayjs(value) : null}
            onChange={(newValue) => {
                handleFilterChange({
                    target: {
                        name: type,
                        value: newValue ? newValue.format('YYYY-MM-DD') : ''
                    }
                });
            }}
            inputProps={{
                ...inputProps,
                sx: {
                    '& .MuiInputBase-root': {
                        height: '40px'
                    },
                    ...inputProps?.sx
                }
            }}
        />
    );
};

export default WrapperDatePicker;